import { render, staticRenderFns } from "./CustomServer.vue?vue&type=template&id=494b6bb5"
import script from "./CustomServer.vue?vue&type=script&lang=js"
export * from "./CustomServer.vue?vue&type=script&lang=js"
import style0 from "./CustomServer.vue?vue&type=style&index=0&id=494b6bb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports